import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=197c4024&scoped=true"
import script from "./EditTable.vue?vue&type=script&lang=js"
export * from "./EditTable.vue?vue&type=script&lang=js"
import style0 from "./EditTable.vue?vue&type=style&index=0&id=197c4024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c4024",
  null
  
)

export default component.exports